export const SITE_ASSET_BUCKET = "stand-site-assets";
export const SITE_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp", "image/avif", "image/gif"];
export const SITE_FAVICON_TYPES = ["image/png", "image/x-icon", "image/vnd.microsoft.icon"];
export const SITE_VIDEO_TYPES = ["video/mp4", "video/webm"];
export const MB = 1024 * 1024;

export const safeSiteAssetExtension = (file: File) => ({
  "image/jpeg": "jpg", "image/png": "png", "image/webp": "webp", "image/avif": "avif",
  "image/gif": "gif", "image/x-icon": "ico", "image/vnd.microsoft.icon": "ico",
  "video/mp4": "mp4", "video/webm": "webm",
} as Record<string, string>)[file.type] ?? "bin";

export function SiteAssetPicker({ label, description, requirements, accept, file, current, disabled, onFile, onRemove }: {
  label: string; description: string; requirements: string; accept: string; file?: File; current: string | null;
  disabled: boolean; onFile: (file: File) => void; onRemove: () => void;
}) {
  return <div className="site-asset-field">
    <span>{label}</span>
    <small className="site-field-explanation">{description}</small>
    <label className="site-file-button">
      <input type="file" accept={accept} disabled={disabled} onChange={(event) => {
        const selected = event.target.files?.[0];
        if (selected) onFile(selected);
        event.target.value = "";
      }} />
      <b>{file || current ? "Substituir ficheiro" : "Escolher ficheiro"}</b>
    </label>
    <div className="site-file-meta">
      <small className="site-file-name">{file ? file.name : current ? "Ficheiro atual guardado" : "Nenhum ficheiro escolhido"}</small>
      <small>{requirements}</small>
    </div>
    <button type="button" className="site-file-remove" onClick={onRemove} disabled={!file && !current} aria-hidden={!file && !current}>Remover</button>
  </div>;
}
